import { render } from "./InputZipCode.vue?vue&type=template&id=5af3aa4a"
import script from "./InputZipCode.vue?vue&type=script&lang=ts"
export * from "./InputZipCode.vue?vue&type=script&lang=ts"
script.render = render

export default script